/**
 * The club cover document (design_handoff_club_pages/README.md §Cover) — the same shape the Pro
 * page keeps (`proPageModel.coverFromBiz`), fed from ClubDto / PublicClubDto, plus the API adapter
 * that lets the one `ProCoverEditor` save through the club endpoints.
 */
import clubService from '../../services/clubService';
import proService from '../../services/proService';
import { DEFAULT_RATIO } from '../event/coverLayout';

const num = (v, fallback = 50) => {
  const n = Number(v);
  return Number.isFinite(n) ? Math.max(0, Math.min(100, n)) : fallback;
};

/** Photos in cover order with framing, the saved layout / split / count and the card pick. */
export function coverFromClub(club, ratios = {}) {
  const photos = (club?.photos || []).map((p, i) => ({
    id: p.id || `p${i}`, src: p.url, path: p.path, r: ratios[p.url] || DEFAULT_RATIO, measured: !!ratios[p.url],
    fx: num(p.focalX), fy: num(p.focalY),
  }));
  return {
    photos,
    layout: club?.coverLayout || 'auto',
    split: [60, 50, 40].includes(Number(club?.coverSplit)) ? Number(club.coverSplit) : 60,
    count: Number(club?.coverPhotoCount || 0),
    cardId: club?.cardPhotoId || null,
  };
}

/** The photos that make the cover: the first `count` (all when unset). */
export function coverSlice(cover) {
  const n = cover.photos.length;
  if (!n) return [];
  const k = cover.count > 0 ? Math.min(cover.count, n) : n;
  return cover.photos.slice(0, k);
}

/** What `ProCoverEditor` / `CoverVideoField` call, pointed at one club. */
export const clubCoverApi = (clubId) => ({
  updateCover: (payload) => clubService.updateCover(clubId, payload),
  uploadAsset: (file) => clubService.uploadCoverPhoto(clubId, file),
  video: {
    get: () => clubService.getCoverVideo(clubId),
    startUpload: () => clubService.startCoverVideoUpload(clubId),
    uploadFile: (url, file) => proService.uploadCoverVideoFile(url, file),
    setEmbed: (url) => clubService.setCoverVideoEmbed(clubId, url),
    clear: () => clubService.clearCoverVideo(clubId),
  },
});

/** The editor's club wording (README §Cover editor). */
export const CLUB_COVER_COPY = {
  intro: 'The club’s logo and name sit on the left. Drag any photo on the cover to choose what stays in frame.',
  cardNote: 'Order sets which photo goes where. The CARD photo is the one people see on the club’s card under Clubs.',
  pageWord: 'club page',
};
